import Color from 'color';
import merge from 'lodash/merge';
import { CustomTheme } from './types';
import { defaultFontFamily, PartialCustomTheme } from './Theme';
import { mb } from './mbTokens';

export const getResolvedTheme = (customizedTheme?: PartialCustomTheme): CustomTheme => {
  const primaryColor = Color(customizedTheme?.palette?.primary || mb.green);
  const textColor = Color(customizedTheme?.palette?.text?.primary || '#3f4648');
  const background = Color(customizedTheme?.palette?.background || mb.surface);

  const baseTheme: CustomTheme = {
    darkLogo: false,
    palette: {
      border: mb.control,
      primary: primaryColor.hex(),
      background: background.hex(),
      trackFill: primaryColor.hex(),
      railFill: primaryColor.lighten(0.3).hex(),
      handle: primaryColor.hex(),
      warning: mb.clayInk,
      error: mb.danger,
      text: {
        primary: mb.ink,
        footer: textColor.lighten(0.15).hex(),
        button: { contained: 'white', outlined: primaryColor.hex(), numberSelector: background.hex() },
      },
      toggleButton: {
        disabledBg: mb.ground,
        selectedBg: mb.mint,
      },
      lineColor: textColor.lighten(0.2).hex(),
      calendarPicker: {
        disabledArrow: customizedTheme?.darkLogo ? textColor.darken(0.7).hex() : textColor.lighten(0.7).hex(),
        availableDay: {
          background: '#4CAF50',
          hover: '#66BB6A',
          selected: '#388E3C',
        },
        fullyBookedDay: {
          background: '#FF5A5F',
          hover: '#FFB5B8',
          selected: '#D62828',
        },
        runningOutDay: {
          background: '#FFC107',
          hover: '#FFD54F',
          selected: '#FFA000',
        },
      },
    },

    typography: {
      fontFamily: customizedTheme?.typography?.fontFamily || defaultFontFamily,
      h1: {
        fontSize: '32px',
        fontWeight: 'bold',
      },

      h3: {
        fontSize: '20px',
        fontWeight: 'normal',
      },
      h6: {
        fontSize: '16px',
        fontWeight: 'normal',
      },
      body: {
        fontSize: '14px',
        fontWeight: 'normal',
      },
    },
  };

  return merge(baseTheme, customizedTheme);
};
